import { IconStyleDictionary, IconStyleKey } from '@varo/graphql-schema-types';
import { Maybe } from 'shared/utils/types';

import { IconKeyType } from './Icon';

/**
 * a utility for mapping IconStyleDictionary to IconKeyType
 * components should define icon sizing so expect to lose size info
 * with this function
 */
export const iconKeyForStyleDictionary = (
  styleDictionary: IconStyleDictionary,
): Maybe<IconKeyType> => {
  const { iconKey: gqlIconKey } = styleDictionary;
  switch (gqlIconKey) {
    case IconStyleKey.UndefinedIconStyleKey:
      return null;
    case IconStyleKey.DirectDepositMedium:
      return 'DIRECT_DEPOSIT';
    case IconStyleKey.TransferMedium:
      return 'TRANSFER';
    case IconStyleKey.InfoMedium:
      return 'INFO';
    case IconStyleKey.ArrowUpMedium:
      return 'ARROW_UP';
    case IconStyleKey.ArrowDownMedium:
      return 'ARROW_DOWN';
    case IconStyleKey.MoneyMedium:
      return 'MONEY';
    case IconStyleKey.PiggyBankMedium:
      return 'PIGGY_BANK';
    case IconStyleKey.VaroToVaroMedium:
      return 'VARO_TO_VARO';
    case IconStyleKey.SkipMedium:
      return 'SKIP';
    case IconStyleKey.Calendar:
      return 'CALENDAR';
    case IconStyleKey.CashDStaticSquare:
      return null;
    case IconStyleKey.CreditScore:
      return 'CREDIT_SCORE';
    case IconStyleKey.ErrorLarge:
      return 'ERROR';
    case IconStyleKey.ErrorMedium:
      return 'ERROR';
    case IconStyleKey.FlashOn:
      return 'FLASH_ON';
    case IconStyleKey.LightbulbLarge:
      return 'LIGHT_BULB';
    case IconStyleKey.ListCheckmarkLarge:
      return 'LIST_CHECK_MARK';
    case IconStyleKey.ListCheckmarkMedium:
      return 'LIST_CHECK_MARK';
    case IconStyleKey.ListCheckmarkSmall:
      return 'LIST_CHECK_MARK';
    case IconStyleKey.LockFilledSmall:
      return 'LOCK_FILLED';
    case IconStyleKey.SuccessLarge:
      return 'SUCCESS';
    case IconStyleKey.SuccessMedium:
      return 'SUCCESS';
    case IconStyleKey.Sun:
      return 'SUN';
    case IconStyleKey.GiftMedium:
      return 'GIFT';
    case IconStyleKey.ListXmarkMedium:
      return 'LIST_CHECK_MARK';
    case IconStyleKey.ListXmarkLarge:
      return 'LIST_CHECK_MARK';
    case IconStyleKey.CircleMedium:
      return 'CIRCLE';
    case IconStyleKey.LockSmall:
      return 'LOCK';
    case IconStyleKey.LockMedium:
      return 'LOCK';
    case IconStyleKey.CircleLarge:
      return 'CIRCLE';
    case IconStyleKey.GiftLarge:
      return 'GIFT';
    case IconStyleKey.ListWarningMarkMedium:
      return 'LIST_WARNING_MARK';
    case IconStyleKey.LightbulbMedium:
      return 'LIGHT_BULB';
    case IconStyleKey.CalendarMedium:
      return 'CALENDAR';
    case IconStyleKey.CashbackMedium:
      return 'CASHBACK';
    case IconStyleKey.CardMedium:
      return 'CARD';
    case IconStyleKey.SparkleMedium:
      return 'SPARKLE';
  }
};
